import type { AABB2 } from "geom/aabb2Types";
import * as THREE from "three";
import { RenderPass } from "./threejs/examples/jsm/postprocessing/RenderPass";
import type { ExtendedWebGLRenderer } from "./threejs/three-extensions";

export class OverlayScene {
  readonly scene: THREE.Scene;
  readonly renderPass: RenderPass;

  constructor(
    public readonly id: string,
    public readonly sortIndex: number,
    public readonly worldScissorRect?: AABB2,
    clearStencil?: number | undefined,
    public readonly isLineworkUnderlay?: boolean,
  ) {
    this.scene = new THREE.Scene();
    this.scene.onBeforeRender = (renderer, _scene, _camera) => {
      (renderer as ExtendedWebGLRenderer).filteredClippingPlanes = [];
    };

    this.renderPass = new RenderPass(this.scene, undefined, undefined, undefined, undefined, clearStencil);

    this.renderPass.clear = false;
    this.renderPass.clearDepth = true;
  }

  setCamera(camera: THREE.Camera) {
    this.renderPass.camera = camera;
  }

  setupRenderPass(worldAABBToPixelAABB?: (aabb: AABB2) => THREE.Box2) {
    if (this.worldScissorRect) {
      if (worldAABBToPixelAABB) {
        const pixelScissorRect = worldAABBToPixelAABB(this.worldScissorRect);
        this.renderPass.scissorRect = pixelScissorRect;
      } else {
        console.warn("worldAABBToPixelAABB is not defined, cannot setup scissor rect for overlay scene.");
      }
    }

    this.renderPass.enabled = this.scene.children.length > 0;
    return this.renderPass;
  }
}
